import React, { Suspense } from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import ReleaseGrid from "../components/release/ReleaseGrid";
import ReleaseStats from "../components/release/ReleaseStats";

import "../styles/release.css";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateReleaseTile from "../components/release/CreateReleaseTile";

export default function Releases() {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Suspense fallback={<StatSkeleton />}>
          <ReleaseStats />
        </Suspense>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <CreateReleaseTile />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined">
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <ReleaseGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
